import { Fragment, useEffect, useState } from 'react';
import { List } from '@mui/material';
import * as React from 'react';
import useSidebar from 'features/sidebar/hooks/use-sidebar';
import Loader from 'shared/components/loader';
import SidebarItem from 'features/sidebar/components/sidebar-menu-item';
import { filterRegularDomainSidebarMenuItems } from 'features/sidebar/utils/monitoring-sidebar-filter.util';

type Props = {
  openSidebar: boolean;
};

const SidebarListMenuItems: React.FC<Props> = (props) => {
  const [openedItems, setOpenedItems] = useState<string[]>([]);
  const { sidebarState, getSidebarMenuItems } = useSidebar();

  useEffect(() => {
    getSidebarMenuItems();
  }, [getSidebarMenuItems]);

  useEffect(() => {
    if (!props.openSidebar) {
      setOpenedItems([]);
    }
  }, [props.openSidebar]);

  if (sidebarState.loadingStatus) {
    return <Loader />;
  }

  const menuItems = filterRegularDomainSidebarMenuItems(
    sidebarState.listSidebarMenuItems
  );

  return (
    <List
      sx={{ bgcolor: 'background.paper', mt: '16px', p: '8px' }}
      component="nav"
    >
      {menuItems.map((item, index) => (
        <Fragment key={index}>
          <SidebarItem
            disabled={!!item.disabled}
            menuItem={item}
            setOpenedItems={setOpenedItems}
            openedMenuItems={openedItems}
          />
        </Fragment>
      ))}
    </List>
  );
};

export default SidebarListMenuItems;
